import { PortableText } from "@portabletext/react";
import PickupLocation from '@/components/location/PickupLocation';
import styles from './styles.module.scss';
import { portableTextComponents } from '@/lib/portableTextComponents';
import SkeletonPickupLocation from "@/components/skeletons/SkeletonPickupLocation";

export function PickupStores({ pickupStores, title, titleColor, subtitle, subtitleColor, text }) {
	return (
		<div className={styles.pickupStores}>
			<div className={styles.contentWrapper}>
				{title && (
					<h2
						className={styles.title}
						style={
							titleColor
								? { color: `rgba(${titleColor.rgb.r},${titleColor.rgb.g},${titleColor.rgb.b},${titleColor.rgb.a})` }
								: {}
						}
					>
						{title}
					</h2>
				)}
				{subtitle && (
					<h3
						className={styles.subtitle}
						style={
							subtitleColor
								? { color: `rgba(${subtitleColor.rgb.r},${subtitleColor.rgb.g},${subtitleColor.rgb.b},${subtitleColor.rgb.a})` }
								: {}
						}
					>
						{subtitle}
					</h3>
				)}
				{text && (
					<div className={styles.content}>
						<PortableText value={text} components={portableTextComponents} />
					</div>
				)}
			</div>

			<div className={styles.pickupLocations}>
				{pickupStores && pickupStores.length > 0 ? (
					pickupStores.map((store) => (
						<PickupLocation key={store.id} store={store} />
					))
				) : (
					<>
						<SkeletonPickupLocation />
						<SkeletonPickupLocation />
					</>
				)}
			</div>
		</div>
	);
}
